"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaiaStreamClient = void 0;
var GaiaStreamClient = /** @class */ (function () {
    function GaiaStreamClient(options, transporter) {
        this.options = options;
        this.transporter = transporter;
    }
    GaiaStreamClient.prototype.post = function (body, urlPostfix) {
        if (urlPostfix === void 0) { urlPostfix = ''; }
        return this.transporter.transport(this.options, JSON.stringify(body), urlPostfix);
    };
    GaiaStreamClient.prototype.postStream = function (data, requestParameters, urlPostfix) {
        if (urlPostfix === void 0) { urlPostfix = ''; }
        var requestOptions = this.options
            .withContentType('application/octet-stream')
            .withRequestParameters(requestParameters);
        return this.transporter.transport(requestOptions, data, urlPostfix);
    };
    GaiaStreamClient.prototype.postAndRetrieveBinary = function (body, urlPostfix) {
        if (urlPostfix === void 0) { urlPostfix = ''; }
        return this.transporter.transportAndRetrieveBinary(this.options, body, urlPostfix);
    };
    return GaiaStreamClient;
}());
exports.GaiaStreamClient = GaiaStreamClient;
//# sourceMappingURL=GaiaStreamClient.js.map